const COLOR_PATTERN = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

export const primaryThemeTokens = theme => {
  const color = theme?.brand_color;
  if (typeof color !== 'string' || !COLOR_PATTERN.test(color)) return {};

  const hex = color.slice(1);
  const expanded =
    hex.length === 3
      ? hex
          .split('')
          .map(value => value.repeat(2))
          .join('')
      : hex;
  const rgb = [0, 2, 4].map(index =>
    Number.parseInt(expanded.slice(index, index + 2), 16)
  );
  const primary = rgb.join(' ');
  const hover = rgb.map(value => Math.round(value * 0.85)).join(' ');

  return {
    '--atende-brand': primary,
    '--atende-brand-hover': hover,
    '--blue-9': primary,
    '--blue-10': hover,
  };
};

// Apenas tokens fixos do Tailwind; nenhum CSS recebido do cadastro é executado.
export const applyAppearanceTheme = (element, theme) => {
  const tokens = primaryThemeTokens(theme);
  const previous = Object.keys(tokens).map(name => ({
    name,
    value: element.style.getPropertyValue(name),
    priority: element.style.getPropertyPriority(name),
  }));
  Object.entries(tokens).forEach(([name, value]) => {
    element.style.setProperty(name, value);
  });

  return () => {
    previous.forEach(({ name, value, priority }) => {
      if (value) element.style.setProperty(name, value, priority);
      else element.style.removeProperty(name);
    });
  };
};
